module.exports = __webpack_public_path__ + "static/media/EHS-Complaints-Policy.d5f76ba5.pdf";